<template>
  <div class="odiv" v-loading="loading">
    <p class="charg_p">
      &nbsp; <span v-show="!this.routerId">新增患者</span>
      &nbsp; <span v-show="this.routerId">修改详情</span>
    </p>
    <div class="form">
      <el-row class="containRow" :gutter="0">
        <el-col :span="16">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="姓名" style="margin-bottom: 12px">
              <span style="color: red">* </span>
              <el-input v-model="form.name" class="input"></el-input>
            </el-form-item>
            <el-form-item label="性别" style="margin-bottom: 12px">
              <span style="color: red">* </span>
              <el-radio-group v-model="form.gender">
                <el-radio label="男"></el-radio>
                <el-radio label="女"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="类型" style="margin-bottom: 12px">
              <span style="color: red">* </span>
              <el-radio-group v-model="form.diagnosisType">
                <el-radio label="新诊"></el-radio>
                <el-radio label="复诊"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="会员等级" style="margin-bottom: 12px;">
              <span style="color: red">* </span>
              <el-select v-model="levelSelected" @change="selectOne(levelSelected)">
                <el-option v-for="item in userLevelType" :key="item.id" :value="item.id"
                       :label="item.levelName">
                </el-option>
              </el-select>
              <span style="color: red">这里的等级选择不影响积分,办卡如需增加相应积分请选择“当前积分”后的按钮，系统会增加相应积分并更新等级</span>
              <!--<span style="color: red">{{scorePoint}}</span>-->
              <!--<span style="color: red">{{availDays}}</span>-->
            </el-form-item>
            <el-form-item label="当前积分" style="margin-bottom: 12px">
            &nbsp;&nbsp;<el-input v-model="form.scoreAvail" style="height: 30px;
    width: 22%;"disabled></el-input>
                  <el-radio-group v-model="radio">
                    <el-radio :label="1">银卡+1000积分</el-radio>
                    <el-radio :label="2">金卡+2000积分</el-radio>
                    <el-radio :label="3">白金卡+4000积分</el-radio>
                  </el-radio-group>
            </el-form-item>

            <el-form-item label="证件号码" style="margin-bottom: 12px">
              <span style="color: red">* </span>
              <el-input v-model="form.idNumber" class="input" placeholder="请输入身份证号"
                    @blur.prevent="changeCount()"></el-input>
            </el-form-item>
            <el-form-item label="手机号" style="margin-bottom: 12px">
              <span style="color: red">* </span>
              <el-input v-model="form.mobileNumber" class="input"></el-input>
            </el-form-item>
            <el-form-item label="出生年月" style="margin-bottom: 12px">
              &nbsp;&nbsp;<el-input v-model="form.dateOfBirth" class="input" disabled></el-input>
            </el-form-item>
            <el-form-item label="周岁" style="margin-bottom: 12px">
              <span style="color: red">* </span>
              <el-input v-model="form.age" class="input" disabled></el-input>
            </el-form-item>

            <el-form-item label="账号" style="margin-bottom: 12px">
              <span style="color: red">* </span>
              <el-input v-model="form.account" placeholder="账号默认为手机号" disabled class="input"></el-input>
            </el-form-item>
            <el-form-item label="密码" v-show="!this.routerId" style="margin-bottom: 12px">
              <span style="color: red">* </span>
              <el-input v-model="form.password" class="input" disabled></el-input>
            </el-form-item>
            <el-form-item label="密码" v-show="this.routerId" style="margin-bottom: 12px">
              <span style="color: red">* </span>
              <el-input v-model="psw" class="input" disabled></el-input>
            </el-form-item>
            <el-form-item label="现住址" style="margin-bottom: 12px" v-show="this.routerId">
              <span style="color: red">* </span>
              <el-input  v-model="form.address" class="input"></el-input>
            </el-form-item>
            <el-form-item label="现住址" style="margin-bottom: 12px" v-show="!this.routerId">
              <span style="color: red">* </span>
              <el-cascader ref="cascaderAddr"
                  :options="CityInfo" v-model="form.selectedOptions" :change-on-select="true"
                     :clearable="true"  @change="handleChange">
              </el-cascader>
              <el-input v-model="form.detailAddress" style="height: 30px;
    width: 48%;" placeholder="详细地址: 如道路、门牌号、小区、楼栋号、单元室等"></el-input>
            </el-form-item>

            <el-form-item label="邮箱">
              &nbsp;&nbsp;<el-input v-model="form.email" class="input"></el-input>
            </el-form-item>
            <el-form-item label="职业" style="margin-bottom: 12px">
              &nbsp;&nbsp;<el-input v-model="form.professional" class="input"></el-input>
            </el-form-item>
<!--            <el-form-item label="额度" style="margin-bottom: 12px">-->
<!--              &nbsp;&nbsp;<el-input v-model="form.quota" class="input" disabled></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="可用额度" style="margin-bottom: 12px">
              &nbsp;&nbsp;<el-input v-model="form.quota" style="height: 30px;width: 22%;" disabled></el-input>
              <el-radio-group v-model="invest">
                <el-radio :label="1">充卡5000送200</el-radio>
                <el-radio :label="2">充卡10000送500</el-radio>
                <el-radio :label="5">自定义金额充卡<el-input v-model="form.recharge" style="height: 10px;width: 22%;"></el-input></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="提现余额" style="margin-bottom: 12px">
              &nbsp;&nbsp;<el-input v-model="form.deposit" style="height: 30px;width: 22%;" disabled></el-input>
              <el-radio-group v-model="invest" v-if="form.deposit > 0">
                <el-radio :label="3">全额消费</el-radio>
                <el-radio :label="4">余额退款</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="额度透支" style="margin-bottom: 12px">
              &nbsp;&nbsp;<el-input v-model="form.overdraw" style="height: 30px;width: 22%;" disabled></el-input>
            </el-form-item>
            <el-form-item label="提示" style="margin-bottom: 12px">
              &nbsp;&nbsp;带<span style="color: red">*</span>的为必填字段

            </el-form-item>
            <el-form-item style="margin-bottom: 12px">
              <el-button type="primary" @click="create_user" v-show="!this.routerId">立即创建</el-button>
              <el-button type="primary" @click="update_user" v-show="this.routerId">保存</el-button>
              <el-button type="info" plain @click="cancel">取消</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple Info">
            <patientinquiry v-if="finish" v-on:objList="objList" :cmsg="objList2" :sex="form.gender" :rId="this.routerId"></patientinquiry>
            <!--新增病人的时候不展示侧边病史 -->
            <!--
            <patientinquiry v-if="!this.routerId" v-on:objList="objList" :cmsg="objList2" :sex="form.gender" :rId="this.routerId"></patientinquiry>
            -->
            </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<style type="text/css" scoped>
  .el-button--primary {
    color: #fff;
    background-color: rgb(60, 110, 169);
    border-color: rgb(60, 110, 169);
  }

  .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #fff;
    background-color: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
    color: #fff;
  }

  .odiv {
    width: 100%;
    padding-bottom: 50px;
    background-color: white;
  }

  .form {
    margin-top: 5px;
  }

  .input {
    height: 30px;
    width: 70%;
  }

  .charg_p {
    border-bottom: 1px solid #e7e7e7;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.68);
    line-height: 50px;
  }
</style>
<script>
  import Patientinquiry from "./patientinquiry";
  import CityInfo from "../../common/cityInfo";

  export default {
    data() {
      return {
        radio:0,
        invest: 0,
        loading: false,
        routerId: '',
        objList1: [],
        objList2: {},
        CityInfo: CityInfo,
        form: {
          name: "",
          account: "",
          address: "",
          cityAddress: "",
          detailAddress:"",
          selectedOptions: [],//地区筛选数组
          age: '',
          diagnosisType: '',
          allergicHistory: "",
          dateOfBirth: "",
          email: "",
          familyHistory: "",
          gender: "",
          idNumber: "",
          income: "",
          maritalStatus: "",
          medicalHistory: "",
          memberships: "",
          menstrual: "",
          mobileNumber: "",
          national: "",
          outpatientType: "",
          password: "123456",
          professional: "",
          roleName: "患者",
          quota: 0,
          deposit: 0,
          overdraw: 0,
          recharge: 0,
          scoreAll: 0,
          scoreAvail:0,
          actualAmount: 0,
          giftAmount: 0,
        },
        psw: "******",
        userLevelType: [],
        levelSelected: "",
        scorePoint: "",
        availDays: "",
        finish: false
      }
    },
    components: {
      patientinquiry: Patientinquiry
    },
    mounted: function () {
      this.routerId = this.$route.query.id;
      if (this.routerId) {
        this.getinfo();
      }
      this.getleveltypeinfo();
    },
    methods: {
      handleChange(value) {
        // element 2.7 删除了 this.$refs['cascaderAddr'].currentLabels 改用新的方法实现
        let addressArr = this.$refs['cascaderAddr'].getCheckedNodes()[0].pathLabels;
        this.form.cityAddress = addressArr.join(',');
      },
      changeCount: function () {
        let len = this.form.idNumber.length
        if (this.form.idNumber != '' && len == 18) {
          let str = this.form.idNumber;
          str = str.substring(6, 14);
          let reg = /^[0-9]+.?[0-9]*$/
          console.log(reg.test(str));
          if (!reg.test(str)) {
            this.$alert('请输入正确身份证号码')
            return false
          }
          str = str.substring(0, 4) + "-" + str.substring(4, 6) + "-" + str.substring(6, 8);
          let nowDateTime = new Date();
          let birthDate = new Date(str);
          let year = nowDateTime.getFullYear();
          let str0_4 = str.substring(0, 4);
          let age = year - str0_4;
          if (nowDateTime.getMonth() < birthDate.getMonth() ||
              (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
            age--;
          }
          this.form.age = age;
          this.form.dateOfBirth = str;
        }
        if (this.form.idNumber != '' && len == 15) {
          let str = this.form.idNumber;
          str = str.substring(6, 12);
          let reg = /^[0-9]+.?[0-9]*$/
          console.log(reg.test(str));
          if (!reg.test(str)) {
            this.$alert('请输入正确身份证号码')
            return false
          }
          str = "19" + str.substring(0, 2) + "-" + str.substring(2, 4) + "-" + str.substring(4, 6);
          let nowDateTime = new Date();
          let birthDate = new Date(str);
          let year = nowDateTime.getFullYear();
          let str0_4 = "19" + this.form.idNumber.substring(6, 8);
          let age = year - str0_4;
          if (nowDateTime.getMonth() < birthDate.getMonth() ||
              (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
            age--;
          }
          this.form.age = age;
          this.form.dateOfBirth = str;
        }
      },

      objList: function (obj) {
        this.objList1 = obj;
      },
      getinfo: function () {
        this.$axios({
          url: '/api/user/' + this.routerId,
          method: 'GET'
        }).then(res => {
          let resdata = res.data.data
          this.form = res.data.data;
          let address =  this.form.address.split(",");
          let length = address.length;
          this.form.detailAddress = address[length];
          this.objList2 = {
            allergicHistory: resdata.allergicHistory,
            familyHistory: resdata.familyHistory,
            lifePartialAddicted: resdata.lifePartialAddicted,
            menstrual: resdata.menstrual,
            virusCarryingHistory: resdata.virusCarryingHistory,
            pathogenyAndPathology: resdata.pathogenyAndPathology,
            sideInformationA: resdata.sideInformationA,
            routerid: this.routerId
          };
          this.levelSelected = parseInt(this.form.level);
          if (res.data.data.diagnosisType == '0') {
            this.form.diagnosisType = '新诊'
          } else {
            this.form.diagnosisType = '复诊'
          }
          this.finish = true;
        }).catch(err => {
          // console.log(err.data);
        })
      },

      getleveltypeinfo: function () {
        this.$axios({
          url: '/api/userlevel/all',
          method: 'GET'
        }).then(res => {
          // console.log(res.data)
          this.userLevelType = res.data.data;
        }).catch(err => {
          // console.log(err.data);
        })
      },

      selectOne: function (item) {
        var userTypes = this.userLevelType;
        this.availDays = '可提前预约天数：' + userTypes[item - 1].availDays;
        this.scorePoint = '基础积分：' + userTypes[item - 1].scorePoint + '；';
      },

      //创建
      create_user() {

        if (this.form.diagnosisType == '新诊') {
          this.form.diagnosisType = 0;
        } else if (this.form.diagnosisType == '复诊') {
          this.form.diagnosisType = 1
        }
        if (this.form.mobileNumber != '') {
          this.form.account = this.form.mobileNumber
        }
        // console.log(JSON.stringify(this.form));
        let a = this.form.name;
        let b = this.form.age;
        let c = this.form.mobileNumber;
        let d = this.form.account;
        let f = this.form.idNumber;
        let levelSelectedVar = this.levelSelected;
        if (a === '') {
          this.$alert('姓名不能为空');
          return false
        }
        if (b === '') {
          this.$alert('周岁不能为空');
          return false
        }
        if (c === '') {
          this.$alert('手机号不能为空');
          return false
        }
        if (d === '') {
          this.$alert('账号不能为空');
          return false
        }

        if (f === '') {
          this.$alert('身份证不能为空');
          return false
        }
        if(this.form.cityAddress === '' ||  this.form.detailAddress === ''){
          this.$alert('请检查现住址的完整性');
          return false
        }
        if (levelSelectedVar === '') {
          this.$alert('会员类型不能为空');
          return false
        } else {
          var userTypes = this.userLevelType;
          if(this.radio != 0){
            this.form.scoreAll = userTypes[this.radio].scorePoint;
            this.form.scoreAvail = userTypes[this.radio].scorePoint;
            this.form.level = userTypes[this.radio].levelType;
          }
          else {
            this.form.scoreAll = 0;
            this.form.scoreAvail = 0;
            this.form.level = userTypes[this.levelSelected - 1].levelType;
          }
        }
        if(this.invest == 1){
          this.form.actualAmount = 5000;
          this.form.giftAmount = 200;
        }
        else if(this.invest == 2){
          this.form.actualAmount = 10000;
          this.form.giftAmount = 500;
        }
        else if(this.invest == 5){
          this.form.actualAmount = this.form.recharge;
          this.form.giftAmount = 0;
        }
        else {
          this.form.actualAmount = 0;
          this.form.giftAmount = 0;
        }
        this.$delete(this.form, 'allergicHistory');
        this.$delete(this.form, 'familyHistory');
        this.$delete(this.form, 'lifePartialAddicted');
        this.$delete(this.form, 'menstrual');
        this.$delete(this.form, 'virusCarryingHistory');
        this.$delete(this.form, 'pathogenyAndPathology');
        this.$delete(this.form, 'sideInformationA');
        this.form.address = this.form.cityAddress + ','+this.form.detailAddress;
        this.loading = true;
        this.$axios({
          url: '/api/user',
          method: 'POST',
          data: this.form
        }).then(res => {
          if (res.data.code == 200) {
            this.loading = false;
            this.$message({
              type: 'success',
              message: '新增成功'
            })
            this.$router.push({path: './patientlist'});
          }
          else {
            this.loading = false;
            this.$message({
              type: 'failed',
              message: res.data.msg
            })
          }
        }).catch(err => {
          // console.log(err.data);
        })
        // console.log(this.form)
      },

      //修改保存
      update_user() {
        if (this.form.diagnosisType == '新诊') {
          this.form.diagnosisType = 0;
        } else if (this.form.diagnosisType == '复诊') {
          this.form.diagnosisType = 1
        }
        if (this.form.mobileNumber != '') {
          this.form.account = this.form.mobileNumber
        }
        let a = this.form.name;
        let b = this.form.age;
        let c = this.form.mobileNumber;
        let d = this.form.account;
        let e = this.form.password;
        let f = this.form.idNumber;
        let g = this.form.address;
        let levelSelectedVar = this.levelSelected;
        if (a == '') {
          this.$alert('姓名不能为空');
          return false
        }
        if (b == '') {
          this.$alert('周岁不能为空');
          return false
        }
        if (c == '') {
          this.$alert('手机号不能为空');
          return false
        }
        if (d == '') {
          this.$alert('账号不能为空');
          return false
        }

        if (f == '') {
          this.$alert('身份证不能为空');
          return false
        }
        if (g == '') {
          this.$alert('地址不能为空');
          return false
        }
        if (levelSelectedVar == '') {
          this.$alert('会员类型不能为空');
          return false
        }else {
          var userTypes = this.userLevelType;
          if(this.radio != 0){
            this.form.scoreAll = userTypes[this.radio].scorePoint;
            this.form.scoreAvail = userTypes[this.radio].scorePoint;
          }else{
            this.form.scoreAll = 0;
            this.form.scoreAvail = 0;
          }
          this.form.level = userTypes[this.levelSelected - 1].levelType;
        }
        if(this.invest == 1){
          this.form.actualAmount = 5000;
          this.form.giftAmount = 200;
        }
        else if(this.invest == 2){
          this.form.actualAmount = 10000;
          this.form.giftAmount = 500;
        }
        else if(this.invest == 3){  // 全额消费
          this.form.actualAmount = - this.form.quota;
          this.form.giftAmount = 0;
        }
        else if(this.invest == 4){  // 余额退款
          this.form.actualAmount = - this.form.deposit;
          this.form.giftAmount = this.form.deposit - this.form.quota;
        }
        else if(this.invest == 5){
          this.form.actualAmount = this.form.recharge;
          this.form.giftAmount = 0;
        }
        else {
          this.form.actualAmount = 0;
          this.form.giftAmount = 0;
        }
        this.$delete(this.form, 'allergicHistory');
        this.$delete(this.form, 'familyHistory');
        this.$delete(this.form, 'lifePartialAddicted');
        this.$delete(this.form, 'menstrual');
        this.$delete(this.form, 'virusCarryingHistory');
        this.$delete(this.form, 'pathogenyAndPathology');
        this.$delete(this.form, 'sideInformationA');
        this.$axios({
          url: '/api/user/' + this.routerId,
          method: 'PUT',
          data: this.form
        }).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.$router.push({path: './patientlist'});
          }
          else {
            this.$message({
              type: 'failed',
              message: res.data.msg
            })
          }

        }).catch(err => {
          // console.log(err.data);
        })
        // console.log(this.form)
      },
      cancel: function () {
        this.$router.push({path: './patientlist'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// addone.vue?74e4e0a0